import { Modal, Input, Form } from 'antd';

const CodeModal = ({ isVisible, contestant_code, handleCodeChange, handleModalToggle, handleSubmitCode }) => (
    <Modal
        title="Enter Contestant Code"
        visible={isVisible}
        onOk={handleSubmitCode}
        onCancel={() => handleModalToggle('isCodeModalVisible')}
    >
        <Form layout='vertical'>
            <Form.Item label="Contestant Code">
                <Input placeholder='Enter contestant code' value={contestant_code} onChange={handleCodeChange} />
            </Form.Item>
        </Form>
    </Modal>
);

export default CodeModal;  
